"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var SelectMenu_1 = __importDefault(require("./Types/SelectMenu"));
var Integrations_1 = require("./Integrations");
var WebCaptureIntegration_1 = __importDefault(require("./Types/WebCaptureIntegration"));
var Integrations_module_css_1 = __importDefault(require("./Integrations.module.css"));
var react_i18next_1 = require("react-i18next");
var IntegrationEditorModal = function (props) {
    var _a;
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)(null), selectedIntegrationType = _b[0], setSelectedIntegrationType = _b[1];
    var isIntegrationSelected = (props.mode === "edit" && props.integration || props.mode === "new" && selectedIntegrationType) ? true : false;
    var headerText = isIntegrationSelected
        ? ""
        : props.mode === "edit"
            ? ((_a = props.integration) === null || _a === void 0 ? void 0 : _a.name) || t("Select integration")
            : (selectedIntegrationType === null || selectedIntegrationType === void 0 ? void 0 : selectedIntegrationType.name) || t("Select integration");
    var modalBodyStyle = isIntegrationSelected ? { paddingTop: "70px" } : {};
    var logger = q_play_core_1.logManager.getLogger();
    var _c = (0, react_1.useState)(false), creationError = _c[0], setCreationError = _c[1];
    var createIntegration = function (integrationData) { return __awaiter(void 0, void 0, void 0, function () {
        var isUpdate, endpoint, method, body, request, response, newIntegration, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isUpdate = integrationData.web_capture_integration_id != null && !isNaN(integrationData.web_capture_integration_id);
                    endpoint = isUpdate ? "/api/integration/".concat(integrationData.web_capture_integration_id) : "/api/integration";
                    method = isUpdate ? "PUT" : "POST";
                    body = JSON.stringify({
                        type: integrationData.type,
                        name: integrationData.name,
                        urls: integrationData.urls.map(function (url) { return (__assign({}, url)); }),
                        email: integrationData.email,
                        password: integrationData.password,
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = onlineResourceManager.makeJSONRequest(endpoint, method, body);
                    return [4 /*yield*/, request.getResponseRaw()];
                case 2:
                    response = _a.sent();
                    if (response.status === 200 || response.status === 201) {
                        setCreationError(false);
                        if (!isUpdate && props.setIntegration) {
                            newIntegration = __assign(__assign({}, response.data), { shouldFetchNew: true, urls: integrationData.urls });
                            props.setIntegration(newIntegration);
                        }
                        if (isUpdate && props.setIntegration) {
                            props.setIntegration(__assign(__assign({}, props.integration), { shouldFetchNew: true, urls: integrationData.urls }));
                        }
                        return [2 /*return*/, __assign(__assign({}, response.data), { urls: integrationData.urls })];
                    }
                    else {
                        setCreationError(true);
                        logger.error("Non-200 response:", response);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setCreationError(true);
                    logger.error("Error in saving integration:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleIntegrationNameChange = function (newName) {
        return new Promise(function (resolve, reject) {
            if (props.setIntegration && props.integration) {
                props.setIntegration(__assign(__assign({}, props.integration), { name: newName }));
                resolve();
            }
            else {
                reject(new Error("Integration not found or setIntegration not provided"));
            }
        });
    };
    var handleClose = function () {
        setSelectedIntegrationType(null);
        props.toggle();
        setCreationError(false);
    };
    var selectIntegrationType = function (integrationType) {
        setSelectedIntegrationType(integrationType);
        if (props.setIntegration) {
            var newIntegration = { type: integrationType.name, urls: [], name: "", email: "", password: "" };
            props.setIntegration(newIntegration);
        }
    };
    var createEditorBody = function (selectedIntegrationType) {
        if (props.integration && !selectedIntegrationType) {
            selectedIntegrationType = Integrations_1.integrationTypes.find(function (type) { return type.name == props.integration.type; });
        }
        switch (selectedIntegrationType === null || selectedIntegrationType === void 0 ? void 0 : selectedIntegrationType.type) {
            case "webcapture":
                return (react_1.default.createElement(WebCaptureIntegration_1.default, { createIntegration: createIntegration, cancelCreation: handleClose, onSave: handleIntegrationNameChange, integrationType: selectedIntegrationType, integration: props.integration, mode: props.mode, uuidToImageUrlMap: props.uuidToImageUrlMap, creationError: creationError }));
            default:
                return (react_1.default.createElement(SelectMenu_1.default, { integrationTypes: Integrations_1.integrationTypes, selectIntegrationType: selectIntegrationType }));
        }
    };
    var body = (react_1.default.createElement(react_1.default.Fragment, null, createEditorBody(selectedIntegrationType)));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: handleClose, headerText: headerText, body: react_1.default.createElement("div", { style: modalBodyStyle }, body), centered: true, dataCy: "IntegrationEditorModal", dialogClassName: Integrations_module_css_1.default.create_integration_modal }));
};
exports.default = IntegrationEditorModal;
